module.exports = __webpack_public_path__ + "media/img/222-1f66684f9ced61f1ea7da4d313b5062f.png";